var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/navigation/ic-arrow-back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,11 L7.83,11 L12.7124956,6.11750442 C13.1018612,5.7281388 13.1018612,5.0968524 12.7124956,4.70748678 C12.7116652,4.70665638 12.7108333,4.70582746 12.71,4.705 L12.707098,4.7021184 C12.316175,4.31394844 11.6849363,4.3150637 11.2953874,4.70461259 L4.70710678,11.2928932 C4.31658249,11.6834175 4.31658249,12.3165825 4.70710678,12.7071068 L11.295,19.295 C11.6843607,19.6843607 12.3156393,19.6843607 12.705,19.295 L12.705,19.295 C13.0944628,18.9055372 13.0947454,18.2741804 12.7056314,17.8843691 L7.83,13 L19,13 C19.5522847,13 20,12.5522847 20,12 L20,12 C20,11.4477153 19.5522847,11 19,11 Z",
    id: "path-arrow-back"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/ic-arrow-back",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-arrow-back"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/navigation/arrow_back_24px",
    fill: "#333340",
    xlinkHref: "#path-arrow-back"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowBack);
export default __webpack_public_path__ + "static/media/ic-arrow-back.274bd8ed9fc405c640e1cd10688212cc.svg";
export { ForwardRef as ReactComponent };